import type { AsyncDataOptions } from '#app'

import { AsyncDataKeys } from '@/constants/async-data-keys'
import { getFilter } from '@/service/filter'

import type { EatigoFilterFilterRes } from '@/types/api'
import type { GetFiltersReqParams } from '@/types/filters'

interface UseFilterOpts {
  tagId?: ReadonlyRef<string | number | undefined>
  categoryId?: ReadonlyRef<string | undefined>
  asyncDataOpts?: AsyncDataOptions<EatigoFilterFilterRes>
}

export function useFilters({ tagId, categoryId, asyncDataOpts }: UseFilterOpts = {}) {
  const { regionId } = useRegion()

  const filterOptionsParams = computed<GetFiltersReqParams>(() => ({
    region_id: regionId.value,
    ...(!!categoryId?.value && { category_id: categoryId.value }),
  }))

  const filterOptionsPromise = useAsyncData(
    useAsyncDataKey(AsyncDataKeys.FILTER_OPTIONS, [regionId.value, tagId?.value, categoryId?.value]),
    async () => {
      const { data } = await getFilter(filterOptionsParams.value)
      return data
    },
    {
      watch: [filterOptionsParams],
      ...asyncDataOpts,
    }
  )

  return filterOptionsPromise
}
